import styled, { keyframes } from 'styled-components';

const bannerPulse = keyframes`
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(33, 150, 243, 0.5);
  }
  50% {
    transform: scale(1.02);
    box-shadow: 0 0 18px 6px rgba(33, 150, 243, 0.45);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(33, 150, 243, 0.5);
  }
`;

const bannerShimmer = keyframes`
  0% {
    transform: translateX(-120%);
  }
  100% {
    transform: translateX(120%);
  }
`;

export const Carousel = styled('div')`
  position: relative;
  width: 100%;
  border-radius: 8px;
  overflow: hidden;

  .slick-slide img {
    display: block;
    width: 100%;
    height: auto;
  }

  .slick-dots {
    bottom: 12px;

    li button:before {
      font-size: 10px;
      color: #ffffff;
      opacity: 0.55;
    }

    li.slick-active button:before {
      opacity: 0.95;
    }
  }
`;

export const Slide = styled('div')`
  & img {
    display: block;
    width: 100%;
    height: auto;
    border-radius: 8px;
  }
`;

export const SlideLink = styled('a')`
  display: block;
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  cursor: pointer;
  transition: transform 0.2s ease;

  & img {
    display: block;
    width: 100%;
    height: auto;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 60%;
    height: 100%;
    background: linear-gradient(
      120deg,
      transparent 0%,
      rgba(255, 255, 255, 0.55) 50%,
      transparent 100%
    );
    transform: translateX(-120%);
    pointer-events: none;
    opacity: 0;
  }

  &:hover {
    animation: ${bannerPulse} 1.4s ease-in-out infinite;
  }

  &:hover::after {
    opacity: 1;
    animation: ${bannerShimmer} 1.4s ease-in-out infinite;
  }
`;
